export default function Django_Server() {
  return <div>Django_Server Component</div>;
}
